import React from 'react';

const UpperCaseChange = (e, field, form) => {
  const upperCaseValue = e.target.value.toUpperCase();
  form.setFieldValue(field.name, upperCaseValue);
};

export default UpperCaseChange;
